import React from 'react';
import PropTypes from 'prop-types';
import { getColor } from 'core/utils/Styles';

const Triangle = ({ fill, ...props }) => (
	<svg width="1em" height="1em" viewBox="0 0 12 8" {...props}>
		<path fill={fill} d="M6 0l6 8H0z" />
	</svg>
);

Triangle.propTypes = {
	fill: PropTypes.string,
};

Triangle.defaultProps = {
	fill: getColor('primaryBrand'),
};

export default Triangle;
